import React, { useState } from "react";
import styles from "./SwitchButton.module.scss";

interface SwitchButtonProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  className = "",
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleToggle = () => {
    if (disabled) return;
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };

  return (
    <div
      className={`${styles.switchWrapper} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={handleToggle}
    >
      {label && <span className={styles.label}>{label}</span>}

      <div
        className={`${styles.switch} ${isChecked ? styles.checked : ""}`}
        role="switch"
        aria-checked={isChecked}
      >
        <div className={styles.thumb}></div>
      </div>
    </div>
  );
};

export default SwitchButton;
